import { GridAnswers } from "./types";

// localStorage key for an in-progress grid, scoped by tenant+form+session; null when tenant is unknown (caching off).
export const storageKey = (tenantId: string | undefined, formId: string, sessionId: string): string | null =>
  tenantId ? `bi-tabular:${tenantId}:${formId}:${sessionId}` : null;

export const readCachedAnswers = (key: string | null): GridAnswers | null => {
  if (!key || typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as GridAnswers) : null;
  } catch {
    return null;
  }
};

export const writeCachedAnswers = (key: string | null, answers: GridAnswers): void => {
  if (!key || typeof window === "undefined") return;
  try {
    window.localStorage.setItem(key, JSON.stringify(answers));
  } catch {
    // Quota / private-mode failures are non-fatal — the server draft is the durable copy.
  }
};

export const clearCachedAnswers = (key: string | null): void => {
  if (!key || typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    // ignore
  }
};

// Deep-ish merge: cached (local) answers win over server prefill, per cell.
export const mergeAnswers = (server: GridAnswers, cached: GridAnswers | null): GridAnswers => {
  if (!cached) return server;
  const merged: GridAnswers = { ...server };
  Object.keys(cached).forEach(learnerId => {
    merged[learnerId] = { ...(server[learnerId] || {}), ...(cached[learnerId] || {}) };
  });
  return merged;
};
